import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { IconButton, SvgIcon } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import { withStyles } from 'tss-react/mui';
import Tooltip from 'src/components/Tooltip';
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';
import ModalDialogVideo from 'src/components/ModalDialogVideo/index';

import buttonBoxStyle from 'src/views/management/PartyDetailsView/ButtonBox/buttonBox.style';

function ButtonBox({
  classes,
}) {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <Grid
        className={classes.rootBox}
        container
        spacing={0}
      >
        <Grid>
          <Tooltip
            title="Scheduled Connections"
            placement="right-start"
          >
            <IconButton color="secondary" onClick={handleOpen} size="large">
              <SvgIcon fontSize="large">
                <OndemandVideoIcon />
              </SvgIcon>
            </IconButton>
          </Tooltip>
        </Grid>
      </Grid>
      <ModalDialogVideo
        onClose={handleClose}
        isVisible={open}
        videosrc="https://player.vimeo.com/video/1069660838"
        title="Scheduled Connections"
        largeModal
      />
    </>
  );
}

ButtonBox.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(ButtonBox, buttonBoxStyle, { withTheme: true });
